import { ApiClientError, auth } from "@lumberset/api-client";
import { Logo } from "@lumberset/ui";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { meQuery } from "../lib/queries";

/**
 * Frame for signing in: one quiet card in the middle of the screen. Staff who
 * are already signed in go straight to the queue. Anyone else with a session
 * (a Yard Member, say) is told this panel is not for them.
 */
export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ context, location }) => {
    // A set-password link works whoever is signed in here; that page sorts it out.
    if (location.pathname === "/set-password") return { staffOnly: false };
    const { data: session } = await auth.getSession();
    if (!session) return { staffOnly: false };

    try {
      await context.queryClient.ensureQueryData(meQuery);
    } catch (error) {
      const refused = error instanceof ApiClientError && error.status === 403;
      return { staffOnly: refused };
    }
    throw redirect({ to: "/" });
  },
  component: () => (
    <div className="pt-safe pb-safe flex min-h-dvh flex-col items-center justify-center bg-ui-bg-subtle px-4 py-10">
      <Logo className="mb-8 text-[17px]" markClassName="size-7" />
      <div className="w-full max-w-[400px] rounded-xl bg-ui-bg-base p-6 shadow-elevation-card-rest sm:p-8">
        <Outlet />
      </div>
      <p className="txt-compact-xsmall mt-8 text-ui-fg-muted">Staff panel: Review and Support.</p>
    </div>
  ),
});
